// Maximum number of individual Damage positions drawn for one Defect Pattern.
export const MAX_DEFECT_PATTERN_POSITIONS = 300;
